module.exports = __webpack_public_path__ + "static/media/locator.f10fbca4.svg";